import createAuth0Client from '@auth0/auth0-spa-js';
import { decode } from 'jsonwebtoken';
import { secondsToMillis } from './timerHelpers';

export async function getAuth0Client() {
  return createAuth0Client({
    domain: APP_CONFIG.auth0Domain,
    client_id: APP_CONFIG.auth0ClientId, // eslint-disable-line camelcase
    redirectUri: window.location.origin,
    audience: APP_CONFIG.auth0Audience,
  });
}

export async function getValidatedAuthToken(): Promise<string> {
  try {
    const auth0Client = await getAuth0Client();
    const token = await auth0Client.getTokenSilently();

    const { exp } = decode(token) as { exp: number };
    // Check if token is going to expire in 60 seconds
    if (new Date().getTime() > secondsToMillis(exp - 60)) {
      const user = auth0Client.getUser();
      if (user) {
        await auth0Client.loginWithRedirect();
        return await auth0Client.getTokenSilently();
      }
    }
    return token;
  } catch (ex) {
    // eslint-disable-next-line no-console
    console.error('There was an issue validating JWT token', ex);
  }

  return null;
}
